'use strict';

Object.defineProperty(exports, "__esModule", { value: true });
exports.Competitions = void 0;
var transport_1 = require("../../transport");
var Competitions = /** @class */ (function () {
    function Competitions() {
    }
    Competitions.prototype.upcoming = function (params) {
        return transport_1.transport.request('competitions/upcoming', params);
    };
    Competitions.prototype.all = function (params) {
        return transport_1.transport.request('competitions/getAll', params);
    };
    Competitions.prototype.optIn = function (params) {
        return transport_1.transport.request('competitions/optIn', params);
    };
    Competitions.prototype.optOut = function (params) {
        return transport_1.transport.request('competitions/optOut', params);
    };
    Competitions.prototype.leaderboardByAchievement = function (params) {
        return transport_1.transport.request('competitions/leaderboardByAchievement', params);
    };
    Competitions.prototype.get = function (params) {
        return transport_1.transport.request('competitions/get', params);
    };
    Competitions.prototype.getScheduled = function (params) {
        return transport_1.transport.request('competitions/getScheduled', params);
    };
    Competitions.prototype.getScheduledDetails = function () {
        return transport_1.transport.request('competitions/scheduledDetails');
    };
    return Competitions;
}());
exports.Competitions = Competitions;
